import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { APPS } from "@/config";

// First-party, privacy-friendly analytics: no cookies, no storage, no PII.
// Honors the browser's Do Not Track signal. Events: page views + sign-in clicks.
function send(endpoint, body) {
  if (typeof navigator !== "undefined" && navigator.doNotTrack === "1") return;
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/${endpoint}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    /* analytics must never break the page */
  }
}

export default function Analytics() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/og-card")) return;
    send("view", {
      path: pathname,
      referrer: typeof document !== "undefined" ? document.referrer : "",
    });
  }, [pathname]);

  useEffect(() => {
    const onClick = (e) => {
      const target = e.target;
      const link = target && target.closest ? target.closest('a[href]') : null;
      if (!link) return;
      const href = link.href || "";
      const from = window.location.pathname;
      if (href.includes("/login")) {
        const app = APPS.find((a) => href.startsWith(a.loginUrl));
        send("event", {
          name: "sign_in_click",
          meta: { app: app ? app.id : "unknown", from },
        });
      } else if (href.includes("calendar.app.google")) {
        send("event", { name: "book_demo_click", meta: { from } });
      }
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  return null;
}
